module.exports = __webpack_public_path__ + "img/notFoundPedido.e0e2bd4c.png";